export default "__VITE_ASSET__v5OzF5yI__"